import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
var DotRouterService = (function () {
    function DotRouterService(router, loginService) {
        this.router = router;
        this.loginService = loginService;
    }
    DotRouterService.prototype.goToMain = function () {
        this.router.navigate(['/c']);
    };
    DotRouterService.prototype.goToLogin = function (parameters) {
        this.router.navigate(['/public/login'], parameters);
    };
    DotRouterService.prototype.goToURL = function (url) {
        this.router.navigate([url]);
    };
    DotRouterService.prototype.isPublicUrl = function (url) {
        return url.startsWith('/public');
    };
    DotRouterService.prototype.isFromCoreUrl = function (url) {
        return url.startsWith('/fromCore');
    };
    DotRouterService.prototype.isRootUrl = function (url) {
        return url === '/';
    };
    DotRouterService.prototype.gotoPortlet = function (portletId) {
        this.router.navigate(["c/" + portletId.replace(' ', '_')]);
    };
    DotRouterService.prototype.goToForgotPassword = function () {
        this.router.navigate(['/public/forgotPassword']);
    };
    DotRouterService.prototype.goToNotLicensed = function () {
        this.router.navigate(['c/notLicensed']);
    };
    return DotRouterService;
}());
export { DotRouterService };
DotRouterService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
DotRouterService.ctorParameters = function () { return [
    { type: Router, },
    { type: LoginService, },
]; };
//# sourceMappingURL=dot-router.service.js.map